import { DashboardOutlined } from "@ant-design/icons";
import { ActiveProgramsTable } from "components/Tables/ActiveProgramsTable/ActiveProgramsTable";
import { AccountPage } from "components/UI/AccountPage/AccountPage.tsx";
import { SectionContentWrapper } from "components/UI/SectionContentWrapper";
import { getAccountOverviewHeaderItems } from "utils/accountHeaderItems.ts";
import { createAccountFileRoute } from "utils/createAccountFileRoute.ts";

export const Route = createAccountFileRoute("/_authenticated/account/_layout/")({
    component: ActiveProgramsPage,
    staticData: {
        permissions: [],
        isPublic: true,
        showInSideMenu: true,
        label: "pages.account.active-programs.title",
        icon: <DashboardOutlined />,
        sort: 1,
    },
    loader: ({ context: { t } }) => ({
        breadcrumb: t("pages.account.active-programs.title"),
    }),
});

function ActiveProgramsPage() {
    return (
        <AccountPage headerNavigationItems={getAccountOverviewHeaderItems}>
            <SectionContentWrapper withBackground className={"!p-0"}>
                <ActiveProgramsTable />
            </SectionContentWrapper>
        </AccountPage>
    );
}
